import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
   flex-direction: column;
   gap: 0.3rem;
   border-radius: 10px;
   background-color: #ffffff;
   box-shadow: 0 1px 1px #ccc;
   user-select: none;

   span{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0.5rem 0.5rem 0 0 ;
      margin-left: 0.5rem;
      font-style: italic;
      font-size: 0.75rem;
      font-weight: bolder;
   }
`